'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dPresto$0024$0024anon$002414 from "./presto.-Presto$$anon$14.js";
import * as $j_presto$002etypes$0024$002dAccount$002dId$0024 from "./presto.types$-Account-Id$.js";
import * as $j_presto$002etypes$0024$002dEmail$0024 from "./presto.types$-Email$.js";
import * as $j_presto$002etypes$0024$002dMorbid$002dUser$002dDetails$0024 from "./presto.types$-Morbid-User-Details$.js";
var $p;
/** @constructor */
function $c_Lpresto_Presto$$anon$13() {
  this.ba4 = null;
  this.b9W = null;
  this.b9X = false;
  this.ba5 = null;
  this.ba6 = false;
  this.ba9 = null;
  this.ba2 = null;
  this.ba3 = false;
  this.b9Y = null;
  this.b9Z = false;
  this.ba0 = null;
  this.ba1 = false;
  this.ba7 = false;
  this.ba8 = false;
  this.ba4 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.ba9 = "MorbidUserDetails";
}
export { $c_Lpresto_Presto$$anon$13 as $c_Lpresto_Presto$$anon$13 };
$p = $c_Lpresto_Presto$$anon$13.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Presto$$anon$13;
/** @constructor */
function $h_Lpresto_Presto$$anon$13() {
}
export { $h_Lpresto_Presto$$anon$13 as $h_Lpresto_Presto$$anon$13 };
$h_Lpresto_Presto$$anon$13.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.ba4;
});
$p.M = (function() {
  if ((!this.b9X)) {
    this.b9W = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.b9X = true;
  }
  return this.b9W;
});
$p.O = (function() {
  if ((!this.ba6)) {
    this.ba5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.ba6 = true;
  }
  return this.ba5;
});
$p.E = (function() {
  return this.ba9;
});
$p.t = (function() {
  if ((!this.ba3)) {
    this.ba2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("email", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("account", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.ba3 = true;
  }
  return this.ba2;
});
$p.N = (function() {
  if ((!this.b9Z)) {
    this.b9Y = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dEmail$0024.$m_Lpresto_types$Email$().cJ(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dAccount$002dId$0024.$m_Lpresto_types$AccountId$().bl(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.b9Z = true;
  }
  return this.b9Y;
});
$p.Q = (function() {
  if ((!this.ba1)) {
    this.ba0 = new $j_presto$002e$002dPresto$0024$0024anon$002414.$c_Lpresto_Presto$$anon$14();
    this.ba1 = true;
  }
  return this.ba0;
});
$p.v = (function() {
  if ((!this.ba8)) {
    this.ba7 = false;
    this.ba8 = true;
  }
  return this.ba7;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee91) => ((p) => \u03b4scrutinee91.Gp(p)))($j_presto$002etypes$0024$002dMorbid$002dUser$002dDetails$0024.$m_Lpresto_types$MorbidUserDetails$())));
});
var $d_Lpresto_Presto$$anon$13 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Presto$$anon$13, "presto.Presto$$anon$13", ({
  Ni: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_Presto$$anon$13 as $d_Lpresto_Presto$$anon$13 };
//# sourceMappingURL=presto.-Presto$$anon$13.js.map
